import Index from './Index.vue';

export const routes_mi = [
    {
        name: 'Index',
        path: '/',
        component: Index,
    }
];